import React, { useRef } from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import { TProductLink } from "../types/Product";
import ProductController from "../controllers/ProductController";

export interface IProductsProp {
    productId: string;
}

export const useProductLinks = ({ productId }: IProductsProp) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<TProductLink[]>([]);
    const [error, setError] = React.useState<string>('');

    const executing = useRef(false);

    const execute = async () => {
        if (!loading && !executing.current) {
            executing.current = true;
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }

                const response = await ProductController.getLinksByProduct({ productId });
                const responseError = response as IErrorResponse;
                const responseData = response as TProductLink[];

                if (responseError.code) {
                    setError(responseError.error);
                    setData([]);
                } else {
                    setData(responseData);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
                executing.current = false;
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, [productId]);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}